import { render, staticRenderFns } from "./addFlightClass.vue?vue&type=template&id=15f87869&scoped=true&"
import script from "./addFlightClass.vue?vue&type=script&lang=ts&"
export * from "./addFlightClass.vue?vue&type=script&lang=ts&"
import style0 from "./addFlightClass.vue?vue&type=style&index=0&id=15f87869&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f87869",
  null
  
)

export default component.exports